'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdStreetview = function MdStreetview(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.1 10c0 3 1.3 5.7 3.2 7.7l-16.3 16.3c-0.6-0.6-1-1.4-1-2.4v-23.2c0-1.8 1.6-3.4 3.4-3.4h12c-0.8 1.5-1.3 3.2-1.3 5z m2.5 0c0-4.6 3.8-8.4 8.4-8.4s8.4 3.8 8.4 8.4-3.8 8.4-8.4 8.4-8.4-3.8-8.4-8.4z m-0.7 13.9c2.5-1.9 5.7-3 9.1-3 1.7 0 3.4 0.3 5 0.8v9.9c0 1.8-1.6 3.4-3.4 3.4h-11.6v-9.1c0-0.8 0.4-1.5 0.9-2z' })
        )
    );
};

exports.default = MdStreetview;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/streetview.js
// module id = 3375
// module chunks = 0